<template>
  <div>
    <div class="all_body">
      <div class="all_sys1">
        <div class="sys_djgj">
          <div class="sys_djgj_content">
            <div class="sys_djgj_title">
              <div class="sys_djgj_title_1">蛋鸡管家</div>
            </div>
            <div class="sys_djgj_content_bottom">
              <div>5年持续专注蛋鸡产业互联网，</div>
              <div>重磅推出蛋鸡行业智能系统解决方案</div>
            </div>
          </div>
        </div>

        <div class="sys_gongneng">
          <div class="sys_gongneng_left">
            <div class="sys_gongneng_title">功能丰富</div>
            <div
              class="sys_gongneng_content"
            >蛋鸡管家养殖管理系统不仅仅是一个管理系统，而是一套蛋鸡行业养殖标准与解决方案，我们不断做到蛋鸡行业领先、技术快速迭代、陪您一路发展成长的智能伙伴</div>
            <div class="sys_gongneng_bottom">
              <div class="sys_gongneng_bottom_line">
                <div class="sys_gongneng_bottom_line_img">
                  <img :src="sys" />
                </div>
                <div class="sys_gongneng_bottom_line_font">范围：百万羽级蛋鸡养殖集团、5-50万羽中大养殖公司、青年鸡专业级养殖公司</div>
              </div>
              <div class="sys_gongneng_bottom_line">
                <div class="sys_gongneng_bottom_line_img">
                  <img :src="sys" />
                </div>
                <div class="sys_gongneng_bottom_line_font">技术：极简设计、极致效率、敏捷管理，每栋舍饲喂记录1分钟内完成</div>
              </div>
              <div class="sys_gongneng_bottom_line">
                <div class="sys_gongneng_bottom_line_img">
                  <img :src="sys" />
                </div>
                <div class="sys_gongneng_bottom_line_font">应用：轻量化，无感应用、可以关联公众号、小程序等微应用</div>
              </div>
              <div class="sys_gongneng_bottom_line">
                <div class="sys_gongneng_bottom_line_img">
                  <img :src="sys" />
                </div>
                <div class="sys_gongneng_bottom_line_font">
                  解决方案：集成顶级蛋鸡养殖管理方案，从1日龄到540日龄不同阶段1000套实时
                  <br />推送的行业级解决方案，可以为每个栋舍定制属于您专有的饲养方案。
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sys_guimo">
          <div class="sys_guimo_right">
            <div class="sys_guimo_right_title">规模场养殖管理SAAS系统</div>
            <div
              class="sys_guimo_right_content"
            >集成行业内顶级资源蛋鸡养殖管理系统，伴随用户的养殖规模任意系统扩展，陪您发展壮大的智能伙伴，超级API接口让您随时进行外围系统无缝相联</div>
            <div class="sys_guimo_right_button" @click="buy(1)">购买</div>
            <div
              class="sys_guimo_right_bottom"
            >集成顶级蛋鸡养殖管理方案，从1日龄到540日龄不同阶段1000套实时推送的行业级解决方案，可以为每个栋舍定制属于您专有的饲养方案</div>
          </div>
        </div>

        <div class="sys_gongying">
          <div class="sys_gongying_left">
            <div class="sys_gongying_left_title">蛋鸡供应链SAAS系统</div>
            <div class="sys_gongying_left_content">成长性的蛋鸡养殖管理系统、敏捷应用、极简界面、精细化管理、产业链协同</div>
            <div class="sys_gongying_left_button" @click="buy(2)">购买</div>
            <div class="sys_gongying_left_bottom">
              <div>基础设置： 仓库设置、出入库类别、采购模式、销售模式、集团级内部采销模式</div>
              <div>期初设置： 期初数据一键导入</div>
              <div>功能操作： 采购入库、自产入库、销售发货、自产领用、往来调拨</div>
              <div>业务报表： 现存量表： 一目了然查看库存</div>
              <div class="sys_gongying_left_bottom_kong">库存台账： 对每笔出入库记录详细追踪</div>
              <div class="sys_gongying_left_bottom_kong">收发存汇总表： 一键总览按照各种维度的库存收发汇总数据</div>
            </div>
          </div>
        </div>

        <div class="sys_jituan">
          <div class="sys_jituan_left">
            <div class="sys_jituan_left_b">
              <ul>
                <li class="sys_jituan_left_img">
                  <img :src="sypt" />
                </li>
                <li class="sys_jituan_left_title">生意平台</li>
                <li class="sys_jituan_left_content">
                  以"客"为核心的
                  <br />数字化营销
                </li>
              </ul>
              <ul>
                <li class="sys_jituan_left_img">
                  <img :src="yypt" />
                </li>
                <li class="sys_jituan_left_title">运营平台</li>
                <li class="sys_jituan_left_content">
                  以"物"为核心的
                  <br />供应链与制造管理
                </li>
              </ul>
              <ul>
                <li class="sys_jituan_left_img">
                  <img :src="glpt" />
                </li>
                <li class="sys_jituan_left_title">管理平台</li>
                <li class="sys_jituan_left_content">
                  以"财"为核心的
                  <br />集团管控
                </li>
              </ul>
              <ul>
                <li class="sys_jituan_left_img">
                  <img :src="gzpt" />
                </li>
                <li class="sys_jituan_left_title">工作平台</li>
                <li class="sys_jituan_left_content">
                  以"人"为核心的
                  <br />HCM管理与人力共享
                </li>
              </ul>
            </div>
          </div>
          <div class="sys_jituan_right">
            <div class="sys_jituan_right_title">集团级SAAS系统</div>
            <div class="sys_jituan_right_content">蛋鸡养殖集团级生意平台、运营平台、管理平台、工作平台</div>
            <div class="sys_jituan_right_button" @click="buy(3)">购买</div>
            <div
              class="sys_jituan_right_bottom_1"
            >农业顶层设置行业级管理、多集团建模设置、企业自属管理DNA设置：大区管理、产业线设置、战斗序列随意组合</div>
            <div class="sys_jituan_right_bottom_2">
              企业建模： 建立自属的管理模型
              <br />行业设置： 多领域、多细分行业设置
              <br />集团设置： 多集团建模
              <br />管理维度设置： 企业自属管理DNA设置
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Systematic",
  data() {
    return {
      sys: "./static/img/sys.png",
      sypt: "./static/img/sypt.png",
      yypt: "./static/img/yypt.png",
      glpt: "./static/img/gjpt.png",
      gzpt: "./static/img/gzpt.png"
    };
  },
  mounted() {
    this.$store.commit("settab", 6);
    console.log(localStorage.getItem("ticket"))
  },
  methods: {
    buy(e) {
      if(localStorage.getItem("breed") == 1){
        this.$message.success("您已经购买过系统");
        return false
      }
      if (!localStorage.getItem("ticket")) {
        if (e == 1) {
          localStorage.setItem("local", "/Buy_g");
        }
        if (e == 2) {
          localStorage.setItem("local", "/Buy_d");
        }
        if (e == 3) {
          localStorage.setItem("local", "/Buy_g");
        }
        this.$router.push("/Login");
        return false;
      }
      if (e == 1) {
        this.$router.push("/Buy_g");
        localStorage.setItem("local", "/Buy_g");
      }
      if (e == 2) {
        this.$router.push("/Buy_d");
        localStorage.setItem("local", "/Buy_d");
      }
      if (e == 3) {
        this.$router.push("/Buy");
        localStorage.setItem("local", "/Buy_g");
      }
    }
  }
};
</script>
<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.all_sys1 {
  margin-top: 30px;
  width: 100%;
  /* width: 1479px; */
}
.sys_djgj {
  width: 100%;
  height: 642px;
  background: url("~@/assets/1-1.png") no-repeat center center;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.sys_djgj_content {
  margin-left: 971px;
}
.sys_djgj_title {
  display: flex;
  align-items: flex-end;
  padding-top: 223px;
}
.sys_djgj_title_1 {
  font-size: 40px;
  font-weight: 400;
  color: #adff2b;
  letter-spacing: 6px;
}
.sys_djgj_content_bottom {
  margin-top: 65px;
  font-size: 26px;
  font-weight: 300;
  color: #ffffff;
  letter-spacing: 3px;
}
.sys_gongneng {
  width: 100%;
  height: 660px;
  background: url("~@/assets/1-2.png") no-repeat center center;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.sys_gongneng_left {
  margin-left: 76px;
}
.sys_gongneng_title {
  padding-top: 100px;
  font-size: 36px;
  font-size: 400;
  color: #ffffff;
  letter-spacing: 6px;
}
.sys_gongneng_content {
  margin-top: 21px;
  width: 624px;
  height: 83px;
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  color: #ffffff;
  letter-spacing: 2px;
}
.sys_gongneng_bottom {
  margin-top: 130px;
}
.sys_gongneng_bottom_line {
  display: flex;
}
.sys_gongneng_bottom_line {
  margin-top: 20px;
}
.sys_gongneng_bottom_line_img {
  width: 16px;
  height: 16px;
  margin-right: 20px;
  margin-top: 4px;
}
.sys_gongneng_bottom_line_img img {
  width: 100%;
  height: 100%;
}
.sys_gongneng_bottom_line_font {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 1px;
}
.sys_guimo {
  width: 100%;
  height: 659px;
  background: url("~@/assets/1-3.png") no-repeat center center;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.sys_guimo_right {
  margin-left: 780px;
}
.sys_guimo_right_title {
  padding-top: 135px;
  font-size: 36px;
  font-weight: 400;
  color: #adff2b;
  letter-spacing: 6px;
}
.sys_guimo_right_content {
  margin-top: 21px;
  width: 624px;
  height: 83px;
  font-size: 22px;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 2px;
}
.sys_guimo_right_button {
  margin-left: 4px;
  margin-top: 33px;
  width: 100px;
  height: 40px;
  cursor: pointer;
  border-radius: 6px;
  background: #55b233;
  line-height: 40px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}
.sys_guimo_right_bottom {
  margin-top: 51px;
  width: 496px;
  height: 47px;
  font-size: 16px;
  color: #ffffff;
  line-height: 30px;
}
.sys_gongying {
  width: 100%;
  height: 659px;
  background: url("~@/assets/1-4.png") no-repeat center center;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.sys_gongying_left {
  margin-left: 131px;
}
.sys_gongying_left_title {
  padding-top: 140px;
  font-size: 36px;
  font-weight: 500;
  color: #adff2b;
  letter-spacing: 6px;
}
.sys_gongying_left_content {
  margin-top: 21px;
  font-size: 22px;
  letter-spacing: 2px;
  width: 624px;
  height: 53px;
  line-height: 30px;
  color: #ffffff;
}
.sys_gongying_left_button {
  margin-left: 2px;
  margin-top: 33px;
  width: 100px;
  height: 40px;
  cursor: pointer;
  border-radius: 6px;
  background: #55b233;
  line-height: 40px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}
.sys_gongying_left_bottom {
  margin-top: 54px;
  font-size: 16px;
  color: #ffffff;
  width: 610px;
  height: 166px;
  line-height: 30px;
}
.sys_gongying_left_bottom_kong {
  margin-left: 95px;
}
.sys_jituan {
  width: 100%;
  height: 659px;
  /* margin-bottom: 2px; */
  background: url("~@/assets/1-5.png") no-repeat center center;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  display: flex;
}
.sys_jituan_left {
  margin-left: 33px;
  padding-top: 369px;
  width: 775px;
}
.sys_jituan_left_b {
  margin: 0 auto;
  align-items: center;
}
.sys_jituan_left_b ul {
  float: left;
  /* margin-left: 50px; */
  color: #c1c1c1;
  width: 180px;
  text-align: center;
}
.sys_jituan_left_img {
  width: 118px;
  height: 118px;
  margin-left: 25px;
}
.sys_jituan_left_img img {
  width: 100%;
  height: 100%;
}
.sys_jituan_left_title {
  margin-top: 15px;
  font-size: 22px;
  letter-spacing: 6px;
}
.sys_jituan_left_content {
  margin-top: 16px;
  font-size: 14px;
  line-height: 20px;
}
.sys_jituan_right {
  width: 664px;
  margin-left: 50px;
}
.sys_jituan_right_title {
  padding-top: 86px;
  font-size: 36px;
  font-weight: 500;
  color: #adff2b;
  letter-spacing: 6px;
}
.sys_jituan_right_content {
  width: 550px;
  height: 53px;
  margin-top: 21px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  font-weight: 300;
}
.sys_jituan_right_button {
  margin-left: 1px;
  margin-top: 33px;
  width: 100px;
  height: 40px;
  cursor: pointer;
  border-radius: 6px;
  background: #55b233;
  line-height: 40px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}
.sys_jituan_right_bottom_1 {
  margin-top: 107px;
  font-size: 16px;
  width: 615px;
  height: 46px;
  color: #ffffff;
  line-height: 30px;
}
.sys_jituan_right_bottom_2 {
  margin-top: 35px;
  color: #ffffff;
  font-size: 16px;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Systematic.vue